import pinia from "@/store/pinia";
import { useAuthStore } from "@/store/pinia/authStore";
import { useCartStore } from "@/store/pinia/cartStore";
import { useRealtimeStore } from "@/store/pinia/realtimeStore";
import { useUiStore } from "@/store/pinia/uiStore";

const authStore = useAuthStore(pinia);
const cartStore = useCartStore(pinia);
const realtimeStore = useRealtimeStore(pinia);
const uiStore = useUiStore(pinia);

export default {
  name: "AuthStoreMixin",

  computed: {
    authToken() {
      return authStore.token;
    },

    authUserInfo() {
      return authStore.userInfo;
    },

    authCustomer() {
      return authStore.customer;
    },

    authProvider() {
      return authStore.provider;
    },

    authImpersonationOptions() {
      return authStore.impersonationOptions;
    },

    shoppingCartItems() {
      return cartStore.shoppingCartItems;
    },

    shoppingCartItemCount() {
      return cartStore.shoppingCartCount;
    },

    shoppingCartBusy() {
      return cartStore.shoppingCartLoading;
    },

    shoppingCartErrorState() {
      return cartStore.cartError;
    },

    openJobsCountValue() {
      return uiStore.openJobsCount;
    },

    globalSnackbarOpen() {
      return uiStore.globalSnackbar;
    },

    globalSnackbarText() {
      return uiStore.globalSnackbarMessage;
    },

    canShowPrices() {
      return authStore.canShowPrices;
    },
  },

  methods: {
    setAuthToken(token) {
      return authStore.setAuthToken(token);
    },

    updateAuthToken(token) {
      return authStore.updateAuthToken(token);
    },

    setAuthUserInfo(userInfo) {
      return authStore.setAuthUserInfo(userInfo);
    },

    loadCustomerUserInfo() {
      return authStore.loadCustomerUserInfo();
    },

    loadPartnerUserInfo() {
      return authStore.loadPartnerUserInfo();
    },

    loadShoppingCart() {
      return cartStore.loadShoppingCart();
    },

    refreshShoppingCart() {
      return cartStore.refreshShoppingCart();
    },

    addItemToCart(item) {
      return cartStore.addItemToCart(item);
    },

    loginCustomer(credentials) {
      return authStore.loginCustomer(credentials);
    },

    loginPartner(credentials) {
      return authStore.loginPartner(credentials);
    },

    loginPartnerCode(code) {
      return authStore.loginPartnerCode(code);
    },

    logoutUser() {
      return authStore.logoutUser();
    },

    setGlobalSnackbarOpen(isOpen) {
      return uiStore.updateSnackbarOpen(isOpen);
    },

    connectRealtime() {
      return realtimeStore.connect();
    },

    routeRealtime(payload) {
      return realtimeStore.route(payload);
    },

    subscribeRealtime(payload) {
      return realtimeStore.subscribe(payload);
    },

    unsubscribeRealtime(payload) {
      return realtimeStore.unsubscribe(payload);
    },

    sendRealtimeMessage(payload) {
      return realtimeStore.message(payload);
    },
  },
};